import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "./slider.css";
import { HiArrowSmallRight } from "react-icons/hi2";
import { HiArrowSmallLeft } from "react-icons/hi2";

const TestimonialSlider = () => {
  return (
    <div className="">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        navigation={{
          nextEl: ".custom-swiper-button-next",
          prevEl: ".custom-swiper-button-prev",
        }}
        pagination={{ clickable: true }}
        // autoplay={{
        //   delay: 4000,
        //   disableOnInteraction: false,
        // }}
        loop={true}
        spaceBetween={20}
        breakpoints={{
          768: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
      >
        <SwiperSlide className="refrence">
          <div>
            <img
              src="https://www.shutterstock.com/image-photo/calm-weather-on-sea-ocean-600nw-2212935531.jpg"
              alt=""
               loading="lazy"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="refrence">
          <div>
            <img
              src="https://www.tastybite.co.in/uploads/banners/jk8URuaqGbC1210504053817_default.jpg"
              alt=""
               loading="lazy"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="refrence">
          <div>
            <img
              src="https://www.tastybite.co.in/uploads/banners/jk8URuaqGbC1210504053817_default.jpg"
              alt=""
               loading="lazy"
            />
          </div>
        </SwiperSlide>
      </Swiper>

      <div className="custom-swiper-button-prev">
        <HiArrowSmallLeft className="homesliderarr" />
      </div>
      <div className="custom-swiper-button-next">
        <HiArrowSmallRight className="homesliderarr" />
      </div>
    </div>
  );
};

export default TestimonialSlider;
